export class EngagementActivityVm {
    EngagementID: any;
    InstanceId: any;
  }
  